import React, { createContext, useCallback, useContext, useState } from 'react';
import { setCityIdForApi } from 'src/libs/axios';

type CityContextType = {
  cityId: number | null;
  setCityId: (id: number | null) => void;
};

const CityContext = createContext<CityContextType | undefined>(undefined);

export const CityProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [cityId, setCityIdState] = useState<number | null>(null);

  const setCityId = useCallback((id: number | null) => {
    setCityIdState(id);
    setCityIdForApi(id);
  }, []);

  return (
    <CityContext.Provider value={{ cityId, setCityId }}>
      {children}
    </CityContext.Provider>
  );
};

export const useCity = () => {
  const ctx = useContext(CityContext);
  if (!ctx) throw new Error('useCity must be used inside CityProvider');
  return ctx;
};
